export default "__VITE_ASSET__aJ9H9dwD__"